import { render } from "./FormAddress.vue?vue&type=template&id=4513f930&scoped=true"
import script from "./FormAddress.vue?vue&type=script&lang=js"
export * from "./FormAddress.vue?vue&type=script&lang=js"

import "./FormAddress.vue?vue&type=style&index=0&id=4513f930&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4513f930"]])

export default __exports__